const worker = function () {
    return {
        open: false,
        handles: this.$persist([]),
        preloader: true,
        showProducts: false,
        container: document.querySelector('.container--cards-inner'),
        isScrolling: false,

        // Align height for columns inside the comparison table
        setHeight() {
            // Unify cells height for table titles by the first product column
            const titleColumn = document.querySelectorAll('.table-title');
            this.unifyCellsHeight(titleColumn);

            // Unify cells height for all the columns by the first product column
            const inheritedColumns = document.querySelectorAll('.table-column--product');
            inheritedColumns.forEach((column) => {
                const cellsInheritedColumn = column.querySelectorAll('.table-value');
                this.unifyCellsHeight(cellsInheritedColumn);
            });
        },

        // Unify cells function
        unifyCellsHeight(cells) {
            cells.forEach((cell, index) => {
                const cellPrototypeColumn = document.querySelector(`[data-index="${index}"]`);
                if (cellPrototypeColumn) {
                    const cellHeight = cellPrototypeColumn.offsetHeight;
                    cell.style.height = cellHeight + 'px';
                };
            });
        },

        // Add/remove product hadles to/from Local Storage array
        addToCompare() {
            const handle = this.$el.value;

            if (this.handles.includes(handle)) {
                // Remove handle if found
                const handleIndex = this.handles.indexOf(handle);
                this.handles.splice(handleIndex, 1);
            } else {
                this.handles.push(handle);
            }
        },

        // Initialize the checkboxes based on the persisted handles
        initializeCheckboxes() {
            // Initialize the checkboxes state based on the persisted handles
            const checkboxes = document.querySelectorAll('.compare-checkbox');
            checkboxes.forEach((checkbox) => {
                const handle = checkbox.value;
                checkbox.checked = this.handles.includes(handle);
            });
        },

        // Update the state of a specific checkbox based on the local storage handle
        updateCheckboxState(handle) {
            const checkbox = document.querySelector(`#compare-checkbox-${handle}`);

            if (checkbox) {
                checkbox.checked = this.handles.includes(handle);
            }
        },

        // Remove product handles from Local Storage array and update checkbox state
        removeFromCompare(handle) {
            const handleIndex = this.handles.indexOf(handle);

            if (handleIndex !== -1) {
                // Remove handle if found
                this.handles.splice(handleIndex, 1);

                // Update checkbox state
                this.updateCheckboxState(handle);
                this.getProductCards();

                if (this.handles.length < 1) {
                    this.closeTable();
                    this.updateCompareTriggerVisibility();    
                }
            }
        },

        // Function to check the checkbox states and update compareTrigger visibility
        updateCompareTriggerVisibility() {
            const compareCheckboxes = document.querySelectorAll('.compare-checkbox');
            const compareTrigger = document.querySelector('.compare-trigger');

            const anyChecked = Array.from(compareCheckboxes).some((checkbox) => {
                return checkbox.checked;
            });

            compareTrigger.classList.toggle('visible', anyChecked);
        },

        toggleModal() {
            if (this.open == true) {
                this.closeTable ()
            } else {
                this.open = true;
                this.getProductCards();
                document.documentElement.classList.add("lock-all");
            }
        },

        closeTable () {
            this.open = false;
            this.container.innerHTML = '';
            document.documentElement.classList.remove("lock-all");
        },

        setFixedFirstRow() {           
            const firstRow = document.querySelectorAll(".first-row");
            const tableContentOuter = document.querySelector(".table__content"); // scrolled on desktop and horizontally on mobile
            const tableContentInner = document.querySelector(".table__content .container--cards"); // scrolled vertically on desktop

            // Scroll event listeners
            tableContentOuter.addEventListener('scroll', setStylesForFixedCells);
            tableContentInner.addEventListener('scroll', setStylesForFixedCells);

            // Object to store static properties for assigning it to fixed elements in future
            const staticStyles = {};
            // Precompute static styles for each cell
            firstRow.forEach((cell, index) => {
                cell.setAttribute('data-first-row-index', index);
                const dataIndex = cell.getAttribute('data-first-row-index'); 
                const cellRect = cell.getBoundingClientRect();
                const scrollLeft = tableContentOuter.scrollLeft;
                staticStyles[dataIndex] = {
                    left: cellRect.left + scrollLeft,
                    width: cellRect.width
                };
            })

            // Function to add placeholder for a cell to replace fixed element space for smooth scroll
            function addPlaceholder(cell, cellRect, dataIndex) {
                let placeholder = document.getElementById(`placeholder-${dataIndex}`);
                if (!placeholder) {
                    placeholder = document.createElement('div');
                    placeholder.id = `placeholder-${dataIndex}`;
                    placeholder.style.width = cellRect.width + 'px';
                    placeholder.style.height = cellRect.height + 'px';
                    cell.parentNode.insertBefore(placeholder, cell.nextSibling);
                }
            }


            // Assigning new styles for first row cells when they are fixed
            function setStylesForFixedCells() {
                const scrollTopDesktop = tableContentOuter.scrollTop;
                const scrollTopMobile = tableContentInner.scrollTop;
                const scrollLeft = tableContentOuter.scrollLeft; // For mobile

                firstRow.forEach((cell) => {
                    const dataIndex = cell.getAttribute('data-first-row-index');
                    const cellRect = cell.getBoundingClientRect();

                    // Add placeholder for mobile before scroll
                    if (window.innerWidth <= 768) {
                        addPlaceholder(cell, cellRect, dataIndex);
                    }

                    // Check if the top of the element is out of view and assign position fixed and new styles
                    if ((cellRect.top <= 0 && scrollTopDesktop > 50) || (cellRect.top <= 30 && scrollTopMobile > 0)) {
                        cell.style.position = 'fixed';
                        cell.style.left = staticStyles[dataIndex]?.left - scrollLeft + 'px';
                        cell.style.width = staticStyles[dataIndex]?.width + 'px';
                        if (window.innerWidth <= 768) {
                            cell.style.top = '30px';
                        } else {
                            cell.style.top = '0';
                        }

                        // Add placeholder for desktop on scroll
                        if (window.innerWidth > 768) {
                            addPlaceholder(cell, cellRect, dataIndex);
                        }
                    } else {
                        // Set back position static
                        cell.style.position = 'static';

                        // And remove placeholder if exists
                        const placeholder = document.getElementById(`placeholder-${dataIndex}`);
                        if (placeholder) {
                            placeholder.parentNode.removeChild(placeholder);
                        }
                    }
                });
            }
        },

        getProductCards() {
            this.open = true,
            this.preloader = true;
            this.showProducts = false;
            this.container.innerHTML = '';
            if (this.handles.length > 0) {
                this.handles.forEach((handle) => {
                    const url = `${window.Shopify.routes.root}products/${handle}?view=compare-card`;

                    fetch(url)
                        .then((res) => res.text())
                        .then((data) => {
                            const parser = new DOMParser().parseFromString(data, 'text/html');
                            const card = parser.querySelector('.product-card-layout');
                            this.container.insertAdjacentHTML('beforeend', card.innerHTML);  
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                });
                setTimeout(() => {
                    this.preloader = false;
                    this.showProducts = true;
                    this.setFixedFirstRow();
                }, 1500);
            } else return;
        },

        handleScrolling() {
            const scrollLeft = window.scrollX;
            const scrollTop = window.scrollY;

            // Check if both horizontal and vertical scrolling are possible
            if (scrollLeft !== 0 && scrollTop !== 0) {
                // Determine the dominant direction of scrolling
                const isHorizontalScroll = Math.abs(scrollLeft) > Math.abs(scrollTop);

                // If diagonal scrolling is detected, prevent it
                if (isHorizontalScroll) {
                    window.scrollTo(scrollLeft, 0);
                } else {
                    window.scrollTo(0, scrollTop);
                }
            }
        },

        init() {
            this.initializeCheckboxes();
            this.updateCompareTriggerVisibility();

            this.$watch('showProducts', ()=> {
                this.setHeight();
            })

            //  // Add an event listener for scroll events
            window.addEventListener('scroll', () => {
                if (!this.isScrolling) {
                    window.requestAnimationFrame(() => {
                        this.handleScrolling();
                        this.isScrolling = false;
                    });
                }
                this.isScrolling = true;
            });
        }
    }
}

document.addEventListener('alpine:init', () => {
	Alpine.data('worker', worker);
});
